import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
    selector: '[roundBy]',
    standalone: false
})
export class RoundDirective implements OnInit, OnDestroy {
  @Input() roundBy: number = 1;
  @Output() roundValue = new EventEmitter();
  inputValue = new Subject<string>();
  subscription = new Subscription();

  constructor(private _el: ElementRef) {}

  ngOnInit() {
    const sub = this.inputValue.pipe(debounceTime(1000)).subscribe((input) => {
      this.updateInput(input);
    });
    this.subscription.add(sub);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('input', ['$event']) onInputChange(event: any) {
    this.inputValue.next(this._el.nativeElement.value);
  }

  @HostListener('blur') onBlur() {
    this.updateInput(this._el.nativeElement.value);
  }

  private updateInput(input: string) {
    if (!input) {
      this.roundValue.emit(null);
      return;
    }
    const initValue = input.replace(/[^0-9]*/g, '');
    const roundValue = Math.floor(+initValue / this.roundBy) * this.roundBy;
    this._el.nativeElement.value = roundValue;
    this.roundValue.emit(roundValue);
  }
}
